export interface HighlightRange {
  start: number
  end: number
  quote: string
}

/** Fail closed: invalid/stale ranges leave the complete text visible without misleading emphasis. */
export function highlightParts(text: string, ranges: readonly HighlightRange[]) {
  let cursor = 0
  const parts: { text: string; highlighted: boolean; start: number }[] = []
  const redactions = [...text.matchAll(/\[[^\]]*비공개\]/gu)]
  for (const range of [...ranges].sort((a, b) => a.start - b.start)) {
    if (
      !Number.isInteger(range.start) || !Number.isInteger(range.end) ||
      range.start < cursor || range.end <= range.start || range.end > text.length ||
      range.quote.length < 4 || text.slice(range.start, range.end) !== range.quote ||
      redactions.some((match) => range.start < match.index! + match[0].length && range.end > match.index!)
    ) return [{ text, highlighted: false, start: 0 }]
    if (range.start > cursor) parts.push({ text: text.slice(cursor, range.start), highlighted: false, start: cursor })
    parts.push({ text: text.slice(range.start, range.end), highlighted: true, start: range.start })
    cursor = range.end
  }
  if (cursor < text.length) parts.push({ text: text.slice(cursor), highlighted: false, start: cursor })
  return parts
}
